<div class="confirm-modal ig-modal prompt-modal">
  <div class="close-button">
    <mat-icon (click)="close()">clear</mat-icon>
  </div>
  <div class="title">
    {{title}}
  </div>
  <div class="body">
    <div class="message" *ngIf="message">
      <div>{{message}}</div>
    </div>
    <div *ngIf="messages && messages.length > 0" class="message">
      <div *ngFor="let m of messages;let i = index">
        <div>{{m}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="isShowCheckbox" class="checkbox">
    <mat-checkbox [(ngModel)]="doNotShowPromptModal">
      Do not show this message again
    </mat-checkbox>
  </div>
  <div class="cancel-btn pointer" (click)="close()">
    Close
  </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.prompt.modal/show.prompt.modal.component.html